import { useLocation, useNavigate } from "react-router-dom";
import s from "./user.module.css";
import { Card } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import { useEffect, useState } from "react";
import Loder from "../../Loder/Loder";
import { getBaseUrl2 } from "../../utils";

function UserDetails() {
  const [isLoading, setisLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  let user = location?.state?.data;

  console.log(user, " this is the use detauils");
  //   if (!user) return <Loder loading={true} />;
  return (
    // <div style={{ marginBlock: "2rem" }}>
    //   <div className={s["page_heading"]}>
    //     <div className={s["title"]} onClick={() => navigate(-1)}>
    //       <BiArrowBack />
    //       Back
    //     </div>
    //   </div>
    //   <div className="dashboard-section" style={{ paddingInline: "6rem" }}>
    //     <div className={s["profile_approved_container"]}>
    //       <Card className={s["dashbord-content"]}>
    //         <div className={s["business_card_details"]}>
    //           <div className={s["dashboard-card-content"]}>
    //             <div className={s["card-title"]}>
    //               <div style={{ display: "flex", paddingTop: "12px" }}>
    //                 <h2 style={{ margin: "auto" }}>Plan Document</h2>
    //               </div>
    //               <div className={s["partner_profile_detail"]}>
    //                 <div className={s["left_column"]}>
    //                   <span>Account Number:</span>
    //                   <span>Adhar Image:</span>
    //                   <span>Anniversary Date:</span>
    //                   <span>Bank Name:</span>
    //                   <span>Billing Address 1:</span>
    //                   <span>Billing Address 2:</span>
    //                   <span>Billing City:</span>
    //                   <span>Billing Country:</span>
    //                   <span>Billing Pincode:</span>
    //                   <span>Billing State:</span>
    //                   <span>Branch Name:</span>
    //                   <span>Citizenship:</span>
    //                   <span>City:</span>
    //                   <span>Country:</span>
    //                   <span>Created At:</span>
    //                   <span>Customer Name:</span>
    //                   <span>Date of Birth:</span>
    //                   <span>Email:</span>
    //                   <span>Form 60 Image:</span>
    //                   <span>Gender:</span>
    //                   <span>Government ID Proof Image:</span>
    //                   <span>Guardian Proof Image:</span>
    //                   <span>IFSC Code:</span>
    //                   <span>Latitude:</span>
    //                   <span>Longitude:</span>
    //                   <span>Marital Status:</span>
    //                   <span>Mobile:</span>
    //                   <span>Name:</span>
    //                   <span>Nominee Name:</span>
    //                   <span>Nominee Relation:</span>
    //                   <span>PAN ID:</span>
    //                   <span>PAN Image:</span>
    //                   <span>Pincode:</span>
    //                   <span>Plan:</span>
    //                   <span>Salesperson ID:</span>
    //                   <span>Scheme Customer:</span>
    //                   <span>Shipping Address 1:</span>
    //                   <span>Shipping Address 2:</span>
    //                   <span>Shipping City:</span>
    //                   <span>Shipping Country:</span>
    //                   <span>Shipping Pincode:</span>
    //                   <span>Shipping State:</span>
    //                   <span>State:</span>
    //                 </div>
    //                 <div className={s["rigth_column"]}>
    //                   <span>{planDock?.accountNumber || "N/A"}</span>
    //                   <span>
    //                     {planDock?.adharImage?.length ? "Available" : "N/A"}
    //                   </span>
    //                   <span>{planDock?.aniversaryDate || "N/A"}</span>
    //                   <span>{planDock?.bankName || "N/A"}</span>
    //                   <span>{planDock?.billingAddress1 || "N/A"}</span>
    //                   <span>{planDock?.billingAddress2 || "N/A"}</span>
    //                   <span>{planDock?.billingCity || "N/A"}</span>
    //                   <span>{planDock?.billingCountry || "N/A"}</span>
    //                   <span>{planDock?.billingPincode || "N/A"}</span>
    //                   <span>{planDock?.billingState || "N/A"}</span>
    //                   <span>{planDock?.branchName || "N/A"}</span>
    //                   <span>{planDock?.citizenship || "N/A"}</span>
    //                   <span>{planDock?.city || "N/A"}</span>
    //                   <span>{planDock?.country || "N/A"}</span>
    //                   <span>{planDock?.createdAt?.slice(0, 10) || "N/A"}</span>
    //                   <span>{planDock?.customerName || "N/A"}</span>
    //                   <span>{planDock?.dob || "N/A"}</span>
    //                   <span>{planDock?.email || "N/A"}</span>
    //                   <span>
    //                     {planDock?.form60Image?.length ? "Available" : "N/A"}
    //                   </span>
    //                   <span>{planDock?.gender || "N/A"}</span>
    //                   <span>
    //                     {planDock?.governmentIdProofImage?.length
    //                       ? "Available"
    //                       : "N/A"}
    //                   </span>
    //                   <span>
    //                     {planDock?.gurdianProofImage?.length
    //                       ? "Available"
    //                       : "N/A"}
    //                   </span>
    //                   <span>{planDock?.ifscCode || "N/A"}</span>
    //                   <span>{planDock?.lat || "N/A"}</span>
    //                   <span>{planDock?.lng || "N/A"}</span>
    //                   <span>{planDock?.maritalStatus || "N/A"}</span>
    //                   <span>{planDock?.mobile || "N/A"}</span>
    //                   <span>{planDock?.name || "N/A"}</span>
    //                   <span>{planDock?.nomineeName || "N/A"}</span>
    //                   <span>{planDock?.nomineeRelation || "N/A"}</span>
    //                   <span>{planDock?.panId || "N/A"}</span>
    //                   <span>
    //                     {planDock?.panImage?.length ? "Available" : "N/A"}
    //                   </span>
    //                   <span>{planDock?.pincode || "N/A"}</span>
    //                   <span>{planDock?.plan || "N/A"}</span>
    //                   <span>{planDock?.salePersonId || "N/A"}</span>
    //                   <span>{planDock?.schemeCustomer || "N/A"}</span>
    //                   <span>{planDock?.shippingAddress1 || "N/A"}</span>
    //                   <span>{planDock?.shippingAddress2 || "N/A"}</span>
    //                   <span>{planDock?.shippingCity || "N/A"}</span>
    //                   <span>{planDock?.shippingCountry || "N/A"}</span>
    //                   <span>{planDock?.shippingPincode || "N/A"}</span>
    //                   <span>{planDock?.shippingState || "N/A"}</span>
    //                   <span>{planDock?.state || "N/A"}</span>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </Card>
    //     </div>
    //   </div>
    // </div>
    <div style={{ marginBlock: "2rem" }}>
      <div className={s["page_heading"]}>
        <div className={s["title"]} onClick={() => navigate(-1)}>
          <BiArrowBack /> Back
        </div>
      </div>
      <div className="dashboard-section" style={{ paddingInline: "6rem" }}>
        <div className={s["profile_approved_container"]}>
          <Card className={s["dashbord-content"]}>
            <div className={s["business_card_details"]}>
              <div className={s["dashboard-card-content"]}>
                <div className={s["card-title"]}>
                  <div style={{ display: "flex", paddingTop: "12px" }}>
                    <h2 style={{ margin: "auto" }}>User Details</h2>
                  </div>
                  <div className={s["user_image"]}>
                    <img
                      src={getBaseUrl2() + user?.profile_image?.url}
                      alt="profile"
                    />
                  </div>
                  <div className={s["partner_profile_detail"]}>
                    <div className={s["left_column"]}>
                      <span>Name:</span>
                      <span>Email:</span>
                      <span>Gotra:</span>
                      <span>Date of Birth:</span>
                      <span>Phone:</span>
                      <span>Gender:</span>
                      <span>Country:</span>
                      <span>Created At:</span>
                      <span>Login Type of Login:</span>
                    </div>
                    <div className={s["right_column"]}>
                      <span>{user?.name || "N/A"}</span>
                      <span>{user?.email || "N/A"}</span>
                      <span>{user?.gotra || "N/A"}</span>
                      <span>{user?.dob?.slice(0, 10) || "N/A"}</span>
                      <span>{user?.phone || "N/A"}</span>
                      <span>{user?.gender || "N/A"}</span>
                      <span>
                        {user?.country === "IN"
                          ? "INDIA" || "N/A"
                          : user?.country}
                      </span>
                      <span>{user?.created_at?.slice(0, 10) || "N/A"}</span>
                      <span>{user?.loginType || "N/A"}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
